import { Contentful_SiteSettings } from "graphql-types";
import React from "react";
export const SiteSettingsContext: Contentful_SiteSettings | any = React.createContext(null);
